// Analytics ISOLADO do SecBrain — form_id próprio para não misturar com o educascale.
// Os eventos são empurrados para o window.dataLayer (GTM). Use um container GTM
// próprio do SecBrain ao configurar o site.

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>
  }
}

export type CtaLocation =
  | 'hero'
  | 'nav_desktop'
  | 'nav_mobile'
  | 'demonstracao'
  | 'cta_final'
  | 'footer'

export type FormStepName =
  | 'nome'
  | 'telefone'
  | 'email'
  | 'clinica'
  | 'especialidade'
  | 'pacientes'
  | 'faixas'
  | 'desafio'

export const STEP_NUMBER: Record<FormStepName, number> = {
  nome: 1,
  telefone: 2,
  email: 3,
  clinica: 4,
  especialidade: 5,
  pacientes: 6,
  faixas: 7,
  desafio: 8,
}

// ID/labels exclusivos do SecBrain (educascale usa 'diagnostico_landing_chat').
export const FORM_ANALYTICS = {
  form_id: 'agendamento_secbrain_chat',
  form_name: 'Agendar Demonstração',
  method: 'landing_chat',
} as const

export function track(event: string, params: Record<string, unknown> = {}) {
  if (typeof window === 'undefined') return
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({ event, ...params })
}
